import { RootState } from '@/redux-store';

export const selectCompanyRoleById = (id: RootState['reducer']['roles']['companyRoles'][number]['id']) => (
  state: RootState,
) => state.reducer.roles.companyRoles.find(r => r.id === id);
